"use client"
import React from 'react'
import { IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import useFetch from '@/app/useFetch'
import Link from 'next/link';
import { IMG_URL } from '@/app/config';
import { formatDateShort } from '@/app/helpers';
import { useTheme } from '@/app/theme-provider';
import Loader from './Loader';

const Suiwings = () => {
    const {
        theme,
        toggleTheme,
        toggleHighlightLinks,
        highlightLinks,
        language,
        toggleLanguage,
    } = useTheme();
    const { data: list, loading, error } = useFetch(
        "/website/wings-special-investigation-unit",
        []
    );


    return (
        <>
            <div className='row'>
                <div className='col'>
                    <div className='directorate-main'>
                        <h4>{language == "en" ? "SPECIAL INVESTIGATION UNITS" : "പ്രത്യേക അന്വേഷണ യൂണിറ്റുകൾ"}</h4>
                        <p>{language == "en" ? "There are two Special Investigation Units (I & II) headquartered at Thiruvananthapuram which are headed by Superintendents of Police. The Superintendent of Police is assisted by Deputy Superintendents of Police, Inspectors of Police and other field officers, ministerial staff etc. Important Vigilance Cases/Vigilance Enquiries with state-wide ramifications are entrusted to these Units." : "തിരുവനന്തപുരത്ത് ആസ്ഥാനമായി പ്രവർത്തിക്കുന്ന രണ്ട് പ്രത്യേക അന്വേഷണ യൂണിറ്റുകൾ (I & II) ഉണ്ട്, ഇവയ്ക്ക് പോലീസ് സൂപ്രണ്ടുമാർ നേതൃത്വം നൽകുന്നു. ഡെപ്യൂട്ടി പോലീസ് സൂപ്രണ്ടുമാർ, പോലീസ് ഇൻസ്പെക്ടർമാർ, മറ്റ് ഫീൽഡ് ഓഫീസർമാർ, മിനിസ്റ്റീരിയൽ സ്റ്റാഫ് തുടങ്ങിയവർ പോലീസ് സൂപ്രണ്ടിനെ സഹായിക്കുന്നു. സംസ്ഥാനവ്യാപകമായി ഉണ്ടാകുന്ന പ്രധാന വിജിലൻസ് കേസുകൾ/വിജിലൻസ് അന്വേഷണങ്ങൾ ഈ യൂണിറ്റുകളെയാണ് ഏൽപ്പിച്ചിരിക്കുന്നത്."}</p>
                    </div>
                </div>
            </div>
            {loading ? (
                <>
                    <Loader n={24} f={0.3} />

                </>
            ) : <>
                <div className='row g-3 g-lg-4 mt-1'>
                    {list?.length > 0 ? (
                        <>
                            {list?.map((item, index) => (
                                <>
                                    <div key={index} className='col-md-6'>
                                        <div className='mision-card h-100'>
                                            <h4>{item?.name}</h4>
                                            <p>{item?.details}</p>
                                            <div className='ph-email'>
                                                <p>  <IoCall style={{ color: "#ff9500" }} /> {item?.phone}</p>
                                                <a style={{ color: "#ccc" }} href={`mailto:${item?.email}`} className='mx-0 mx-lg-3'><MdEmail style={{ color: "#ff9500" }} /> {item?.email}</a>
                                            </div>
                                        </div>
                                    </div>

                                </>
                            ))}

                        </>
                    ) : <>
                        <h4>No data found</h4>
                    </>}

                </div>

            </>}

        </>
    )
}

export default Suiwings
